<template>
  <div id="ptsvbtn" class="w-full fixed bottom-0 right-0 lg:py-5 xl:py-8 text-center z-50 xl:pl-sb xl:pr-8" style="background: rgba(255,255,255,0.7);">
    <vs-button  class="inline-block w-1/2 float-right lg:w-80 xl:py-5" @click="accept" :disabled="!goodToGo">{{ submitText ? submitText : 'Update' }}</vs-button>
    <vs-button  type="flat" class="inline-block w-1/2 float-right lg:mr-2 lg:w-64 xl:py-5"  v-if="cancel" @click="cancel">{{ cancelText ? cancelText : 'Cancel' }}</vs-button>
  </div>
</template>


<script>

export default {
  props: {
    submitText: String,
    cancelText: String, 
    accept: Function,
    cancel: [Function, Boolean],
    goodToGo: {
      default: true,
      type: Boolean
    }
  }
}

</script>

<style>

#ptsvbtn {
  z-index: 1000 !important;
}

</style>
